import React from 'react';
import { Button } from 'antd';
import {
  datetime,
  type DatetimeType,
  type Moment,
} from '@common/services/datetime';
import { Icon } from '@common/components';

// NOTE: only some `filterFormat: 'dateRange'` columns normalize to [startISO,
// endISO]; the rest store antd v4 RangePicker's own Moment, or null.
export type DateRangeFilterValue =
  | string
  | Moment
  | DatetimeType
  | null
  | undefined;

// NOTE: an absent bound is guarded, not formatted: dayjs and moment both read
// undefined as now, and null formats to an Invalid Date sentinel.
const formatRange = (
  start: DateRangeFilterValue,
  end: DateRangeFilterValue
): string =>
  start && end
    ? `${datetime(start as string).format('L')} - ${datetime(
        end as string
      ).format('L')}`
    : '';

export const DateRangeFilterButton = ({
  keyName,
  startDateArray,
  clearFilter,
}: {
  keyName: string;
  startDateArray: [DateRangeFilterValue, DateRangeFilterValue];
  clearFilter: (value: string) => void;
}) => (
  <Button onClick={() => clearFilter(keyName)}>
    <Icon icon="xMark" kind="light" />
    {formatRange(startDateArray[0], startDateArray[1])}
  </Button>
);
